import {
  ActionButton,
  ActionButtonChildrenType,
  ActionButtonProps,
} from '../button/action-button';
import { PaywallModalWrapper } from './paywall-modal-wrapper';
import { PaywallComponentBaseProps } from './paywall.types';

export interface PaywallActionButtonProps
  extends Omit<PaywallComponentBaseProps, 'children'> {
  actionButtonProps: Omit<ActionButtonProps, 'children'>;
  children: ActionButtonChildrenType;
}

const PaywallActionButton = (props: PaywallActionButtonProps) => {
  const {
    planEntitlementKey,
    isFeatureAvailable,
    actionButtonProps,
    children,
  } = props;

  return (
    <PaywallModalWrapper planEntitlementKey={planEntitlementKey}>
      {({ presentUpgrade, hasEntitlement }) => {
        const isAvailable = isFeatureAvailable
          ? isFeatureAvailable(hasEntitlement)
          : hasEntitlement;

        return (
          <ActionButton
            {...actionButtonProps}
            preventPopoverOnClick={() => !isAvailable}
            buttonProps={{
              ...actionButtonProps.buttonProps,
              onClick: (e) => {
                if (!isAvailable) {
                  e.stopPropagation();
                  e.preventDefault();
                  presentUpgrade();
                }
              },
            }}
          >
            {children}
          </ActionButton>
        );
      }}
    </PaywallModalWrapper>
  );
};

export { PaywallActionButton };
